import styled from "styled-components";

export const DiaHorarioKinesioContainer = styled.div`
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  overflow-y: auto;
`;
export const DiaHorarioKinesioHeader = styled.div`
  padding: 52px 28px 30px 28px;
  display: flex;
  justify-content: center;
  span {
    color: var(--color-latex15);
    text-align: center;
    font-size: 28px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
`;
export const DiaHorarioKinesioBody = styled.div`
  display: flex;
  justify-content: center;
`;

export const DiaHorarioKinesioBoton = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-white);
  font-size: 18px;
  width: 360px;
  height: 38px;
  border-radius: 12px;
  background: var(--color-primary);
  box-shadow: 3px 7px 11px 0px rgba(0, 0, 0, 0.25);
`;

export const DiaHorarioKinesioFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 28px;
`;
